import { render, staticRenderFns } from "./ContactForm2.vue?vue&type=template&id=45f3bb13&scoped=true"
import script from "./ContactForm2.vue?vue&type=script&lang=js"
export * from "./ContactForm2.vue?vue&type=script&lang=js"
import style0 from "./ContactForm2.vue?vue&type=style&index=0&id=45f3bb13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3bb13",
  null
  
)

export default component.exports